import { useMemo } from 'react';

import { SelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';

import { useGetHouseholdIndividualsForAccountOwnerQuery } from '../graphql/GetHouseholdIndividuals.generated';

interface UseAccountOwnerOptionsParams {
  enabled?: boolean;
}

interface UseAccountOwnerOptionsResult {
  options: SelectInputOption<string>[];
  loading: boolean;
}

export function useAccountOwnerOptions({
  enabled = true,
}: UseAccountOwnerOptionsParams = {}): UseAccountOwnerOptionsResult {
  const { householdId } = useHouseholdDetailsContext();

  const { data, loading } = useGetHouseholdIndividualsForAccountOwnerQuery({
    variables: {
      where: {
        id: householdId,
      },
    },
    skip: !householdId || !enabled,
  });

  const options = useMemo<SelectInputOption<string>[]>(() => {
    const individuals = data?.households.edges?.[0]?.node?.clientProfiles ?? [];
    return individuals.map((individual) => ({
      display: individual.displayName,
      value: individual.id,
    }));
  }, [data]);

  return {
    options,
    loading,
  };
}
